import axios from "axios";
import endpoints from "./endpoints";
import { getHeaders } from "../utils/helpers/main";

export const getReasonApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.reasonFetch,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const getReasonByIdApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.reasonFetchById,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const addReasonApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.reasonBase,
    method: "POST",
    headers: getHeaders(),

    data,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const deleteReasonApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.reasonBase,
    method: "DELETE",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export default getReasonApi;
